import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useCallback } from "react";
import { isSpecialLinkClick } from "../../utils/isSpecialLinkClick.js";
import { toStateClass } from "../../utils/toStateClass.js";
function MenuLink({ className, children, external, href, isActive, onClick: onNavigate, suppressTo }) {
  const onClick = useCallback((event) => {
    if (event.nativeEvent instanceof MouseEvent && !isSpecialLinkClick(event.nativeEvent)) {
      onNavigate?.(event);
      if (suppressTo) {
        event.preventDefault();
      }
    }
  }, [onNavigate, suppressTo]);
  return /* @__PURE__ */ jsx(
    "a",
    {
      tabIndex: -1,
      className: classNames(className, toStateClass("active", isActive)),
      href,
      onClick,
      target: external ? "_blank" : void 0,
      rel: external ? "noopener noreferrer" : void 0,
      children
    }
  );
}
export {
  MenuLink
};
//# sourceMappingURL=MenuLink.js.map
